/**
 * Angular imports
 */
import { Component, OnInit } from '@angular/core';

/**
 * Service imports
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';

/**
 * MobBottom Menu Component
 */
@Component({
  selector: 'app-mob-bottom-menu',
  templateUrl: './mob-bottom-menu.component.html',
  styleUrls: ['./mob-bottom-menu.component.scss']
})
export class MobBottomMenuComponent implements OnInit {

  /**
   * Instances created.
   */
  constructor(public mls: NewLanguageService) { }

  /**
   * ngOnInit.
   */
  ngOnInit(): void {
    document.querySelector('body')?.classList?.add('pb-5');
  }

}
